import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class LegacyStaffRoleComponent extends Component {
  static readonly TYPE_ID: string = 'f21f47c34d744029a4d05c645688a785';

  constructor(
    public readonly staffRoleId: string,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return LegacyStaffRoleComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LegacyStaffRoleComponent {
    return new LegacyStaffRoleComponent(
        MapUtils.get<string>(map, 'staffRoleId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'staffRoleId': this.staffRoleId,
    };
  }

  clone(): this {
    return new LegacyStaffRoleComponent(
        this.staffRoleId,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.staffRoleId === this.staffRoleId;
  }
}

export class LegacyStaffRoleComponentBuilder extends DataModelBuilder<LegacyStaffRoleComponent> {
  build(context: SerializationContext, map: SerializedData): LegacyStaffRoleComponent {
    return LegacyStaffRoleComponent.fromMap(context, map);
  }
}
